/**
 * 硬編碼幣種清單（host 端）
 *
 * - 不存資料庫，也不在每個遊戲的錢包配置裡維護
 * - host 依 currency code 在此查表得到符號（shared-web 那側自己也有一份對應的）
 * - 新增 / 修改幣種直接改本檔即可
 *
 * 註：型別在 host 本地定義（host 沒有 shared-web 的 @@/types/game）。
 */

export interface CurrencyConfig {
  /** 幣別代碼，例如 "CNY" */
  code: string
  /** 顯示符號，例如 "¥" */
  symbol: string
  /** 投注大小下限（最小可選投注大小） */
  betSizeMin: number
  /** 投注大小上限（最大可選投注大小） */
  betSizeMax: number
}

// betSizeMin / betSizeMax = 投注大小的上下限（取自营运提供的投注大小档位表：
// min = 最小档、max = 最大档）。改档位时连同这里一起更新。
export const CURRENCY_LIST: readonly CurrencyConfig[] = Object.freeze([
  { code: 'CNY', symbol: '¥', betSizeMin: 0.02, betSizeMax: 4.0 },
  { code: 'USD', symbol: '$', betSizeMin: 0.01, betSizeMax: 0.5 },
  { code: 'EUR', symbol: '€', betSizeMin: 0.01, betSizeMax: 0.4 },
  { code: 'GBP', symbol: '£', betSizeMin: 0.01, betSizeMax: 0.4 },
  { code: 'JPY', symbol: '¥', betSizeMin: 1.0, betSizeMax: 50.0 },
  { code: 'HKD', symbol: 'HK$', betSizeMin: 0.02, betSizeMax: 4.0 },
  { code: 'TWD', symbol: 'NT$', betSizeMin: 0.1, betSizeMax: 10.0 },
  { code: 'KRW', symbol: '₩', betSizeMin: 0.01, betSizeMax: 0.5 },
  { code: 'SGD', symbol: 'S$', betSizeMin: 0.01, betSizeMax: 0.5 },
  { code: 'MYR', symbol: 'RM', betSizeMin: 0.05, betSizeMax: 0.5 },
  { code: 'THB', symbol: '฿', betSizeMin: 0.1, betSizeMax: 10 },
  { code: 'VND', symbol: '₫', betSizeMin: 0.1, betSizeMax: 10.0 },
  { code: 'IDR', symbol: 'Rp', betSizeMin: 0.1, betSizeMax: 20.0 },
  { code: 'PHP', symbol: '₱', betSizeMin: 0.05, betSizeMax: 20.0 },
  { code: 'MMK', symbol: 'K', betSizeMin: 0.01, betSizeMax: 1.0 },
  { code: 'USDT', symbol: '$', betSizeMin: 0.01, betSizeMax: 0.5 },
  { code: 'INR', symbol: '₹', betSizeMin: 0.3, betSizeMax: 30.0 },
  { code: 'MXN', symbol: '$', betSizeMin: 0.1, betSizeMax: 7.5 },
])

/**
 * 依 code 查幣種設定（大小寫不敏感）；查不到回 null
 */
export function findCurrency(code: string | null | undefined): CurrencyConfig | null {
  if (!code) return null
  const upper = code.trim().toUpperCase()
  return CURRENCY_LIST.find((c) => c.code === upper) || null
}
